import IconCarbonHome from '@/shared/icons/IconCarbonHome'
import IconCarbonContentView from '@/shared/icons/IconCarbonContentView'
import IconCarbonTaskAdd from '@/shared/icons/IconCarbonTaskAdd'
import IconCarbonEvents from '@/shared/icons/IconCarbonEvents'
import IconCarbonEventsAlt from '@/shared/icons/IconCarbonEventsAlt'
import IconCarbonIndustry from '@/shared/icons/IconCarbonIndustry'
import IconCarbonCatalog from '@/shared/icons/IconCarbonCatalog'
import IconCarbonPower from '@/shared/icons/IconCarbonPower'
import IconCarbonChart3D from '@/shared/icons/IconCarbonChart3D'
import IconCarbonSettingsServices from '@/shared/icons/IconCarbonSettingsServices'
import IconCarbonCarbonAccounting from '@/shared/icons/IconCarbonCarbonAccounting'
import IconCarbonScript from '@/shared/icons/IconCarbonScript'
import IconCarbonToolKit from '@/shared/icons/IconCarbonToolKit'
import IconCarbonLightning from '@/shared/icons/IconCarbonLightning'
import IconCarbonMobile from '@/shared/icons/IconCarbonMobile'
import IconCarbonBuilding from '@/shared/icons/IconCarbonBuilding'
import IconCarbonRule from '@/shared/icons/IconCarbonRule'
import IconCarbonMonConseillerPerso from '@/shared/icons/IconCarbonMonConseillerPerso'
import IconPhoneCallback from '@/shared/icons/NewDesign/IconPhoneCallback'
import IconCarbonTag from '@/shared/icons/IconCarbonTag'
import IconCarbonTaskAddV2 from '@/shared/icons/IconCarbonTaskAddV2'
import IconCarbonUser from '@/shared/icons/IconCarbonUser'
import IconCarbonPauseOutline from '@/shared/icons/IconCarbonPauseOutline'

export default function getIcon(id) {
  switch (id) {
    case 'breaks':
      return props => <IconCarbonPauseOutline {...props} />
    case 'home':
      return props => <IconCarbonHome {...props} />
    case 'overview':
      return props => <IconCarbonContentView {...props} />
    case 'clientCallbacks':
      return props => <IconPhoneCallback size={props?.size || 16} {...props} />
    case 'form':
      return props => <IconCarbonTaskAdd {...props} />
    case 'formV2':
      return props => <IconCarbonTaskAddV2 {...props} />
    case 'users':
      return props => <IconCarbonEvents {...props} />
    case 'teams':
      return props => <IconCarbonEventsAlt {...props} />
    case 'websalesUsers':
      return props => <IconCarbonUser {...props} />
    case 'offices':
      return props => <IconCarbonBuilding {...props} />
    case 'providers':
      return props => <IconCarbonIndustry {...props} />
    case 'suppliers':
      return props => <IconCarbonCatalog {...props} />
    case 'providerOptions':
      return props => <IconCarbonToolKit {...props} />
    case 'servicesStatus':
      return props => <IconCarbonSettingsServices {...props} />
    case 'assistanceProducts':
      return props => <IconCarbonChart3D {...props} />
    case 'monConseillerPersoProducts':
      return props => <IconCarbonMonConseillerPerso {...props} />
    case 'ipAddresses':
    case 'insurance-app':
      return props => <IconCarbonRule {...props} />
    case 'carbonOffset':
      return props => <IconCarbonCarbonAccounting {...props} />
    case 'logout':
      return props => <IconCarbonPower {...props} />
    case 'devTools':
      return props => <IconCarbonScript {...props} />
    case 'energy-app':
      return props => <IconCarbonLightning {...props} />
    case 'telecom-app':
      return props => <IconCarbonMobile {...props} />
    case 'additionalSales':
      return props => <IconCarbonTag {...props} />
    default:
      return null
  }
}
